import { render, staticRenderFns } from "./legendTairyu.vue?vue&type=template&id=e152db20&scoped=true"
import script from "./legendTairyu.vue?vue&type=script&lang=ts"
export * from "./legendTairyu.vue?vue&type=script&lang=ts"
import style0 from "./legendTairyu.vue?vue&type=style&index=0&id=e152db20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e152db20",
  null
  
)

export default component.exports